<div class="container-input d-flex flex-column" [class.error]="error">
  <ng-content></ng-content>
</div>
